import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import { theme } from '../utils/theme';
import { device } from '../utils/mediaQueries';
import { FaCertificate, FaExternalLinkAlt } from 'react-icons/fa';

const CertificationsSection = styled.section`
  padding: 80px 20px;
  background: ${theme.background};
  color: ${theme.text};
  width: 100%;

  ${device.tablet} {
    padding: 100px 40px;
  }

  ${device.laptop} {
    padding: 120px 60px;
  }
`;

const Container = styled.div`
  max-width: 900px;
  width: 100%;
  margin: 0 auto;
  text-align: center;
`;

const SectionTitle = styled(motion.h2)`
  font-size: clamp(1.75rem, 5vw, 3rem);
  margin-bottom: 1rem;
  color: ${theme.white};
  font-weight: 700;
  letter-spacing: -0.02em;
`;

const Subtitle = styled(motion.p)`
  color: ${theme.secondary};
  font-family: ${theme.fontMono};
  font-size: 0.9rem;
  margin-bottom: 2.5rem;
  letter-spacing: 0.05em;
  
  ${device.tablet} {
    font-size: 1rem;
    margin-bottom: 3rem;
  }
`;

const CertGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 1.25rem;

  ${device.tablet} {
    grid-template-columns: repeat(2, 1fr);
    gap: 1.5rem;
  }

  ${device.laptop} {
    grid-template-columns: repeat(3, 1fr);
  }
`;

const CertCard = styled(motion.div)`
  background: ${theme.cardBackground};
  padding: 1.5rem;
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.05);
  transition: ${theme.transition};
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  height: 100%;
  text-align: left;

  ${device.tablet} {
    padding: 1.75rem;
  }

  &:hover {
    transform: translateY(-5px);
    border-color: rgba(255, 255, 255, 0.12);
  }
`;

const IconWrapper = styled.div`
  font-size: 2rem;
  color: ${theme.secondary};
  margin-bottom: 1rem;

  ${device.tablet} {
    font-size: 2.2rem;
    margin-bottom: 1.25rem;
  }
`;

const CertName = styled.h3`
  font-size: 1.05rem;
  margin-bottom: 0.4rem;
  color: ${theme.white};
  font-weight: 600;
  line-height: 1.3;

  ${device.tablet} {
    font-size: 1.15rem;
  }
`;

const Issuer = styled.p`
  font-size: 0.8rem;
  color: ${theme.secondary};
  margin-bottom: 0.5rem;
  font-family: ${theme.fontMono};
`;

const CertDate = styled.span`
  font-size: 0.75rem;
  color: ${theme.text};
  margin-bottom: 1.25rem;
  display: block;
  font-family: ${theme.fontMono};
  opacity: 0.7;
`;

const CredentialLink = styled.a`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: ${theme.text};
  text-decoration: none;
  font-size: 0.8rem;
  margin-top: auto;
  transition: ${theme.transition};
  padding: 0.25rem 0;
  font-family: ${theme.fontMono};

  &:hover {
    color: ${theme.white};
  }

  ${device.tablet} {
    font-size: 0.85rem;
  }
`;

const Certifications = () => {
  const certifications = [
   
    {
      name: "Java Certificate",
      issuer: "Besant Technologies",
      date: "Dec 2024",
      link: "/certificate/GOKULAKANNAN  java certificate.jpg",
      image: "/certificate/GOKULAKANNAN  java certificate.jpg"
    },
    {
      name: "Internship",
      issuer: "TECHSWOT IT SOLUTIONS",
      date: "Aug 2025",
      link: "/certificate/Intership.jpg"
    },
     {
      name: "Java Spring boot3",
      issuer: "Udemy",
      date: "pursuing",
      link: "#"
    },
    {
      name: "System Hardware",
      issuer: "Vip Systems",
      date: "Pursuing",
      link: "#"
    },
    
  ];

  return (
    <CertificationsSection id="certifications">
      <Container>
        <Subtitle data-aos="fade-up">
          My achievements
        </Subtitle>
        <SectionTitle data-aos="fade-up" data-aos-delay="100">
          Certifications
        </SectionTitle>
        <CertGrid>
          {certifications.map((cert, index) => (
            <CertCard
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              viewport={{ once: true }}
            >
              <IconWrapper>
                <FaCertificate />
              </IconWrapper>
              <CertName>{cert.name}</CertName>
              <Issuer>{cert.issuer}</Issuer>
              <CertDate>{cert.date}</CertDate>
              <CredentialLink href={cert.link} target="_blank" rel="noopener noreferrer">
                View Credential <FaExternalLinkAlt size={10} />
              </CredentialLink>
            </CertCard>
          ))}
        </CertGrid>
      </Container>
    </CertificationsSection>
  );
};

export default Certifications;
